import { render, staticRenderFns } from "./PresentacionList.vue?vue&type=template&id=01148ba2&scoped=true&"
import script from "./PresentacionList.vue?vue&type=script&lang=js&"
export * from "./PresentacionList.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionList.vue?vue&type=style&index=0&id=01148ba2&lang=scss&scoped=true&"
import style1 from "./PresentacionList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PresentacionList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01148ba2",
  null
  
)

export default component.exports